const routes = [
  {
    path: '/bradley-ai',
    name: 'NewBradley',
    meta: {
      requiresAuth: true,
      layout: 'home',
      module: 'new-bradley',
      allowedFlag: 'enabledBradleyAccess',
    },
    component: () =>
      import('@/modules/new-bradley/containers/new-bradley.container.vue'),
    children: [
      {
        path: '',
        name: 'NewBradleyHome',
        component: () =>
          import('@/modules/new-bradley/components/new-bradley-home/new-bradley-home.vue'),
      },
    ],
  },
]

export default routes
